import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class HealthCare extends Component {
  render() {
    return (
      <Fragment>
        <div className="page-title-banner _about">
          <div className="title">
            <h1>Health Care</h1>
          </div>
        </div>

        <div className="page-content container-fluid pt-5">
          <div className="inside-page-section _about container pt-5 pb-5 mb-5">
            <div className="row">
              <div className="box  left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="title mb-5">
                  <h4>
                    Additional Documentary and Licensing Requirements for Nurses
                    and other Health Care Professionals (USA, Canada, & the
                    United Kingdom)
                  </h4>
                </div>
                <div className="text col-12 m-0 mb-1">
                  <p className="text-bold mb-0">
                    A. What are the other requirements to support my
                    application?
                  </p>
                  <p>
                    In addition to the requirements listed on the main FAQ page,
                    you will be required to complete and pass the following
                    credentialing and licensing requirements.
                  </p>
                  <br />
                  <p className="text-sbold">United States of America (USA)</p>
                  <p>1. Eb-3rd Preference Immigrant Visa - For Nurses Only</p>
                  <ul className="bullet pl-5">
                    <li>
                      CGFNS and/or ICHP VisaScreen Certificate (if available)
                    </li>
                    <li>
                      English Proficiency Exam Score Report (TOEFL-ibt or IELTS)
                    </li>
                    <li>NCLEX</li>
                  </ul>
                  <p>
                    2. H1-B (Work) Visa – For Physical & Occupational Therapist
                    (PT & OT)
                  </p>
                  <ul className="bullet pl-5">
                    <li>Credential Review (State Board)</li>
                    <li>
                      Health Care Workers Certificate (VisaScreen), if available
                    </li>
                    <li>TOEFL-iBT</li>
                    <li>License (NPTE or NBCOT)</li>
                  </ul>
                  <br />
                  <p className="text-sbold">Canada</p>
                  <ul>
                    <li>1. IELTS</li>
                    <li>
                      2. Credentialing approval by the Canadian Province
                      Regulatory Body
                    </li>
                  </ul>
                  <br />
                  <p className="text-sbold">United Kingdom (UK)</p>
                  <p className="text-bold">
                    Here are THE ACCEPTED ENGLISH LANGUAGE TEST:
                  </p>
                  <p>
                    1. IELTS band score of at least 6.5 in Writing and at least
                    7 across all other section in one or two sittings based on
                    the approved combination scores of NMC:
                  </p>
                  <div className="row">
                    <div className="table-responsive">
                      <table class="table table-bordered table-hover ">
                        <thead className="thead-dark ">
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Listening</th>
                            <th scope="col">Reading</th>
                            <th scope="col">Writing</th>
                            <th scope="col">Speaking</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">Test1</th>
                            <td>7</td>
                            <td>6.5</td>
                            <td>6.5</td>
                            <td>7</td>
                          </tr>
                          <tr>
                            <th scope="row">Test2</th>
                            <td>6.5</td>
                            <td>7</td>
                            <td>7.5</td>
                            <td>8</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-12 p-3 bg-primary mt-4 mb-5">
                    <p className="text-white">
                      {" "}
                      <span className="text-bold">NOTE:</span> Exams must be
                      taken within 6 months apart.
                    </p>
                  </div>

                  <p>
                    2. An OET score of at least B across all sections in one or
                    two sittings based on the approved combination scores of
                    NMC:
                  </p>
                  <div className="row">
                    <div className="table-responsive">
                      <table class="table table-bordered table-hover ">
                        <thead className="thead-dark ">
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Listening</th>
                            <th scope="col">Reading</th>
                            <th scope="col">Writing</th>
                            <th scope="col">Speaking</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">Test1</th>
                            <td>B</td>
                            <td>B</td>
                            <td>C+</td>
                            <td>B</td>
                          </tr>
                          <tr>
                            <th scope="row">Test2</th>
                            <td>B</td>
                            <td>C+</td>
                            <td>B</td>
                            <td>B</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-12 p-3 bg-primary mt-4">
                    <p className="text-white">
                      {" "}
                      <span className="text-bold">NOTE:</span> Exams must be
                      taken within 6 months apart.
                    </p>
                  </div>
                  <p>
                    Check this link for more information:{" "}
                    <a
                      className="text-primary text-italic text-bold"
                      href="https://www.nmc.org.uk"
                      target="_blank"
                    >
                      https://www.nmc.org.uk
                    </a>
                  </p>
                  <br />
                  <p className="text-sbold">
                    B. What is the salary rate for nurses and health care
                    professionals?
                  </p>
                  <p>
                    For the UK nurses, the Point Based System Tier 2 (General)
                    Visa will be used. The average processing time is at least 4
                    months after passing the English Language Test. This
                    timeline will include NMC Test of Competence (Computer Based
                    Test or CBT), NMC Documentation, Visa Filing, and other
                    documentary requirements. Timeline may take longer if nurse
                    applicant prolongs the completion of documentary
                    requirements or needs more time to prepare for the latter
                    stages.
                  </p>
                  <p className="text-sbold mt-5">
                    C. How long does it take to complete the process?
                  </p>
                  <p>
                    The employment-based 3rd Preference (Eb-3) Immigrant Visa
                    processing generally takes about 18 – 24 months to complete
                    in most States, but may take longer if the visa
                    retrogression is in effect and nurse applicant delays the
                    acquisition and submission of documentary requirements of
                    the U.S. Immigration Office (USCIS), National Visa Center
                    (NVC) and the U.S. Embassy.
                    <br />
                    <br />
                    For PTs and OTs, the H1-b (work) visa processing timeline
                    ranges from 3-6 months. However, prior to visa documentation
                    and filing, applicant must first complete the credentialing
                    requirements and acquire health care workers certificate
                    (VisaScreen). Processing time varies per U.S. state
                    assignment, regulatory bodies and immigration rulings at the
                    time the application is filed.
                    <br />
                    <br />
                    For nurses in U.K, the Point-Based System Tier 2 (General)
                    Visa processing time ranges from 10-15 days. Upon completion
                    of Part 1 of the NMC test of competence, visa filing will be
                    arranged. The Part 2 of NMC test of competence will be taken
                    in the U.K.
                  </p>
                  <p className="text-sbold mt-5">
                    D. Is financial assistance provided by the company that
                    employs me?
                  </p>
                  <p>
                    Employers generally offer financial assistance to cover
                    expenses for examination fees, visa, airfare, and other
                    immigration processing expenses. The full coverage and
                    details of financial assistance package is discussed during
                    the scheduled interview workshop.
                  </p>
                  <p className="text-sbold mt-5">
                    E. I made it through the final interview, would it be
                    possible to take my family to the U.S.A. with me?
                  </p>
                  <p>
                    Yes, if you are under a petition for the Eb-3 immigrant
                    visa. You may include your spouse and unmarried children
                    below 21 years old in the petition.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const { loadingTypes } = state.loading;

  return {
    isLoading: loadingTypes.length > 0,
  };
};

export default withRouter(connect(mapStateToProps)(HealthCare));
